// extracted by mini-css-extract-plugin
export var card = "fullWidthCta-module--card--07605";
export var card__image = "fullWidthCta-module--card__image--6042f";
export var card__text = "fullWidthCta-module--card__text--dbbb0";
export var fullWidthCta = "fullWidthCta-module--fullWidthCta--88dad";